<template>
    <div class="fSize">
        <!--<p>loading...</p>-->
        <!--<van-button size="small">sssssss</van-button>-->
    </div>
</template>
<script>
    //引用vant组件，用什么引什么
    import {gainOpenid} from "@/api/common";
    import {getUser} from "@/api/user";
    import {Toast} from "vant";

    export default {
        components: {
            [Toast.name]: Toast
        },
        data() {
            return {
                //-------
            };
        },
        created() {
            const that = this;
            //---控制头尾显示与隐藏----
            //that.$emit('footer', true);
            //this.$emit('header', false);
            Toast.loading({
                message: "数据加载中...",
                forbidClick: true,
                duration: 0
            });
            //sessionStorage.setItem("openid", "oQv646W72srMaE6NI-f9zGvMcZfA");
            that.initializedData();
        },
        methods: {
            //封装方法
            getUrlParam(name) {
                let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
                let r = window.location.search.substr(1).match(reg); //匹配目标参数
                if (r != null) return unescape(r[2]);
                return null; //返回参数值
            },
            //初始化数据
            initializedData() {
                const that = this;
                let openid = sessionStorage.getItem("openid");
                if (openid == null || openid === "") {
                    let code = that.getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
                    let local = window.location.href;
                    if (code == null || code === "") {
                        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6c997ae386a849af&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect';
                        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx028d7f41d61287cb&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect';

                    } else {
                        that.doOpenid(code); //把code传给后台获取用户信息
                    }
                } else {
                    that.isBang(openid);
                }
            },
            doOpenid: function (code) {
                const that = this;
                gainOpenid({code: code}).then(resp => {
                    if (resp.code === 200) {
                        sessionStorage.setItem("openid", resp.data.openid);
                        sessionStorage.setItem("userInfo", JSON.stringify(resp.data));
                        that.isBang(resp.data.openid);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            //当前是否绑定了用户获取用户
            isBang: function (openid) {
                const that = this;
                getUser({openId: openid}).then(resp => {
                    if (resp.code === 200 && resp.data && resp.data.length > 0) {
                        sessionStorage.setItem("userIsBang", "yes");
                    } else {
                        sessionStorage.setItem("userIsBang", "no");
                    }
                    //根据不同参数跳转不同页面
                    let par = that.getUrlParam("p");
                    let authorityPage = ["report", "buyCard", "user", "order", "companyProfile", "physicalExaminationNotice",
                        "physicalExaminationGuidance", "branchInformation", "appointment", "appointmentDetail", "onlineBooking","occDisSur"
                    ];
                    let auth = authorityPage.findIndex((value, index, arr) => {
                        return value === par;
                    }) === -1;
                    Toast.clear();
                    if (!auth) {
                        if (par === "buyCard") {
                            let id = parseInt(that.getUrlParam("id"));
                            if (id) {
                                that.$router.push({
                                    path: "/" + par,
                                    query: {id: parseInt(id)}
                                });
                            } else {
                                that.$router.push({path: "/" + par});
                            }
                        } else {
                            that.$router.push({path: "/" + par});
                        }
                    } else {
                        Toast("页面非法，禁止访问！");
                    }
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    };
</script>
<style scoped></style>
